import { render, staticRenderFns } from "./_newAccount.vue?vue&type=template&id=d447945a&lang=pug&"
import script from "./_newAccount.vue?vue&type=script&lang=js&"
export * from "./_newAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports